import { useEffect } from 'react';

const useInitializeSnowPlow = (): void => {
  useEffect(() => {
    snowplow('newTracker', 'atrck', 'sp.autolist.com', {
      appId: 'autolist web',
      discoverRootDomain: true,
      forceSecureTracker: true,
      eventMethod: 'get',
      contexts: {
        webPage: true,
        performanceTiming: true,
        gaCookies: true,
      },
    });
    snowplow('setUserIdFromCookie', 'client_guid_timestamp');
    snowplow('enableActivityTracking', 5, 5);
    snowplow('trackPageView');
    snowplow('enableLinkClickTracking');
    snowplow('enableFormTracking');
  }, []);
};

export default useInitializeSnowPlow;
